import { render, staticRenderFns } from "./parallel.vue?vue&type=template&id=b5241040&scoped=true"
import script from "./parallel.vue?vue&type=script&lang=js"
export * from "./parallel.vue?vue&type=script&lang=js"
import style0 from "./parallel.vue?vue&type=style&index=0&id=b5241040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5241040",
  null
  
)

export default component.exports